import { render, staticRenderFns } from "./SaleRecovery.vue?vue&type=template&id=b11b9670&scoped=true&"
import script from "./SaleRecovery.vue?vue&type=script&lang=js&"
export * from "./SaleRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11b9670",
  null
  
)

export default component.exports